class CollectionInfiniteScroll {
  constructor() {
    this.selectors = {
      button: '.view-more-button',
      nextButton: '.pagination__item--next',
      buttonSpinner: '.loading-overlay__spinner',
      container: '#product-grid',
      card: '#product-grid .grid__item',
      paginationWrapper: '.pagination-wrapper',
      loadCount: '.infinite-load__count',
    }

    this.InfiniteScroll
    this.addEventListeners()
    this.renderInfiniteScroll()
  }

  addEventListeners() {
    const self = this
    document.addEventListener('facets-update:start', function () {
      self.destroyInfiniteScroll()
    })

    document.addEventListener('facets-update:end', function () {
      self.renderInfiniteScroll()
    })
  }

  renderInfiniteScroll() {
    const self = this
    self.itemCount = document.querySelector(self.selectors.container).children.length;
    const loadMoreButton = document.querySelector(self.selectors.button)
    const nextAvailable = document.querySelector(self.selectors.nextButton)
    if (loadMoreButton && nextAvailable) {
      const container = document.querySelector(self.selectors.container)
      this.InfiniteScroll = new InfiniteScroll(container, {
        path: self.selectors.nextButton,
        button: self.selectors.button,
        append: self.selectors.card,
        checkLastPage: self.selectors.nextButton,
        scrollThreshold: 800,
        history: false,
      })

      this.InfiniteScroll.on('request', function () {
        loadMoreButton.classList.add('loading')
        loadMoreButton.querySelector(self.selectors.buttonSpinner).classList.remove('hidden')
      })

      this.InfiniteScroll.on('append', function (body, path, items, response) {
        self.itemCount += items.length;
        loadMoreButton.classList.remove('loading')
        loadMoreButton.querySelector(self.selectors.buttonSpinner).classList.add('hidden')
        if (document.querySelector(self.selectors.loadCount)) document.querySelector(self.selectors.loadCount).textContent = self.itemCount;
        // reload images srcsets
        items.forEach((item) => {
          var imgs = item.querySelectorAll('img[srcset]');
          imgs.forEach((img) => {
            img.outerHTML = img.outerHTML;
          });
        });
        const applyFClub = new CustomEvent('fClub:applyFClubAll');
        document.dispatchEvent(applyFClub);
      })

      this.InfiniteScroll.on('last', function () {
        loadMoreButton.style.display = 'none'
      })
    }
  }

  destroyInfiniteScroll() {
    const self = this
    if (self.InfiniteScroll) {
      self.InfiniteScroll.destroy()
    }
  }
}

window.addEventListener('load', function() {
  new CollectionInfiniteScroll()
})